//@flow

import React, { useState } from "react";

import { BruIcon, Slider, SliderFrame } from "@/components";
import type { DnaFrame } from "@/components/DnaAnimation/DnaAnimation";

type Props = {
    frames: DnaFrame[],
};

/**
 * Wrapper around the Slider component that displays the current slide text below the slider.
 *
 * @param frames
 * @return {JSX.Element}
 * @constructor
 */
const DnaSlider = ({frames}: Props): React$Element<"div"> => {
    const [slide, setSlide] = useState(0);
    function renderSlides(didLoad: (index: number) => void) {
        return frames.map((frame: DnaFrame, index: number) => (
            <SliderFrame
                key={index}
                className="slide visual dna"
                didLoad={() => didLoad(index)}
                backgroundImage={{ original: { src: frame.image } }}
            />
        ));
    }
    // The current frame that is displayed in the slider
    const frame = frames[slide];
    return (
        <div>
            <Slider
                styleClass={"slider-dna"}
                autoPlay={false}
                onChanged={index => setSlide(index)}
            >
                {didLoad => renderSlides(didLoad)}
            </Slider>
            <div className="pt-3">
                <BruIcon icon={frame.postfix.icon} />
                <div className="text-muted py-3">{frame.postfix.text}</div>
            </div>
        </div>
    );
};

export default DnaSlider;
